import { put, call, select, takeLatest, all } from "redux-saga/effects";
import { getProxyRelationshipTypes, setProxyRelationship, acceptProxyRelationship, grantProxyRelationship, deleteProxyRelationship, getXealthMessage, eCheckInStatus, encryptCSN } from "../api/epicApi";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";


export default function* epicSaga() {
    //yield takeLatest(types.PROXY_RELATIONSHIP_TYPES, handleProxyRelationshipTypes);
    yield takeLatest(types.PROXY_RELATIONSHIP_SET, handleSetProxyRelationship);
    yield takeLatest(types.PROXY_RELATIONSHIP_ACCEPT, handleAcceptProxyRelationship);
    yield takeLatest(types.PROXY_RELATIONSHIP_GRANT, handleGrantProxyRelationship);
    yield takeLatest(types.PROXY_RELATIONSHIP_DELETE, handleDeleteProxyRelationship);
    yield takeLatest([types.GET_SPECIFIC_XEALTH_MESSAGE], getSpecificXealthMessage);
    yield takeLatest(types.GET_ECHECKIN_STATUS, getECheckInStatus);
    yield takeLatest(types.GET_EPIC_ENCRYPT_CSN, handleEncryptCSN);
}
//Not using this method, since we moved centralized proxy system.
//export function* handleProxyRelationshipTypes(payload) {
//    const start = new Date();
//    const stateData = yield select((state) => state.common);

//    if (stateData && stateData.epicEHRDown === false) {
//        try {
//            yield put({ type: types.PROXY_RELATIONSHIP_TYPES_PENDING });
//            const relationTypes = yield call(getProxyRelationshipTypes, payload.token);
//            yield put({ type: types.PROXY_RELATIONSHIP_TYPES_SUCCESS, types: relationTypes });
//            logAPI("MBHWeb.Saga.Proxy.GetProxyRelationshipTypes", start, null);
//        }
//        catch (error) {
//            console.error(error);
//            logAPI("MBHWeb.Saga.Proxy.GetProxyRelationshipTypes.Failure", start, null, error);
//            yield all([
//                put({ type: types.PROXY_RELATIONSHIP_TYPES_FAILURE }),
//                put({ type: types.AJAX_CALL_ERROR, error })
//            ]);
//        }
//    }
//    else {
//        console.log("epicSaga: epicEHRDown");
//    }
//}

export function* handleSetProxyRelationship(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.PROXY_RELATIONSHIP_SET_PENDING });
            const { token, patientId, patientIdType, proxyId, proxyIdType, relation, fromDate, toDate, comments } = payload;
            const result = yield call(setProxyRelationship, token, patientId, patientIdType, proxyId, proxyIdType, relation, fromDate, toDate, comments);
            yield put({ type: types.PROXY_RELATIONSHIP_SET_SUCCESS, result });
            logAPI("MBHWeb.Saga.Proxy.SetProxyRelationship", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.Proxy.SetProxyRelationship.Failure", start, null, error);
            yield all([
                put({ type: types.PROXY_RELATIONSHIP_SET_FAILURE }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("epicSaga: epicEHRDown");
    }
}

export function* handleAcceptProxyRelationship(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.PROXY_RELATIONSHIP_ACCEPT_PENDING });
            const { token, GrantorId, GrantorDob } = payload.data;
            const result = yield call(acceptProxyRelationship, token, GrantorId, GrantorDob);
            yield put({ type: types.PROXY_RELATIONSHIP_ACCEPT_SUCCESS, result });
            logAPI("MBHWeb.Saga.Proxy.AcceptProxyRelationship", start, null);
            if (payload.callback)  //load proxy information after success
                payload.callback();
        }
        catch (error) {
            logAPI("MBHWeb.Saga.Proxy.AcceptProxyRelationship.Failure", start, null, error);
            yield all([
                put({ type: types.PROXY_RELATIONSHIP_ACCEPT_FAILURE, result: error }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("epicSaga: epicEHRDown");
    }
}

export function* handleGrantProxyRelationship(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.PROXY_RELATIONSHIP_GRANT_PENDING });
            const { token, AccessorName, AccessorEmail, type } = payload.data;
            const result = yield call(grantProxyRelationship, token, AccessorName, AccessorEmail, type);
            if (result === true)
                yield put({ type: types.PROXY_RELATIONSHIP_GRANT_SUCCESS, result });
            else
                yield put({ type: types.PROXY_RELATIONSHIP_GRANT_FAILURE, result });
            logAPI("MBHWeb.Saga.Proxy.GrantProxyRelationship", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.Proxy.GrantProxyRelationship.Failure", start, null, error);
            yield all([
                put({ type: types.PROXY_RELATIONSHIP_GRANT_FAILURE }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("epicSaga: epicEHRDown");
    }
}

export function* handleDeleteProxyRelationship(payload) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.PROXY_RELATIONSHIP_DELETE_PENDING });
            const { patientId, patientIdType } = payload;
            const result = yield call(deleteProxyRelationship, domainData.t, patientId, patientIdType);
            yield put({ type: types.PROXY_RELATIONSHIP_DELETE_SUCCESS, result });
            yield put({ type: types.REFRESH_PROXY_LIST });
            logAPI("MBHWeb.Saga.Proxy.DeleteProxyRelationship", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.Proxy.DeleteProxyRelationship.Failure", start, null, error);
            yield all([
                put({ type: types.PROXY_RELATIONSHIP_DELETE_FAILURE, error }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("epicSaga: epicEHRDown");
    }
}

function* getSpecificXealthMessage(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        if (domain.t && payload.messageId) {
            yield put({ type: types.GET_SPECIFIC_XEALTH_MESSAGE_PENDING });
            const response = yield call(getXealthMessage, domain.t, payload.messageId);
            let message = null;
            if (response && response.twistleMessage) {
                //Added this condition to manage old api reponse.
                if (response.twistleMessage.messages) {
                    message = response.twistleMessage.messages.length > 0 && response.twistleMessage.messages.find(message => message.messageId === payload.messageId);
                } else {
                    message = response.twistleMessage;
                }
            }
            logAPI("MBHWeb.Saga.Epic.GetSpecificXealthMessage.Success", start, null);
            yield put({ type: types.GET_SPECIFIC_XEALTH_MESSAGE_SUCCESS, messageUrl: message && message.originalContent && message.originalContent.url ? message.originalContent.url : null, conversationUrl: message && message.originalContent && message.originalContent.conversation_url ? message.originalContent.conversation_url : null });
        }
    }
    catch (err) {
        yield put({ type: types.GET_SPECIFIC_XEALTH_MESSAGE_FAILURE, errorCode: err && err.status ? err.status : null });
        console.error(err);
        logAPI("MBHWeb.Saga.Epic.GetSpecificXealthMessage.Failure", start, null, JSON.stringify(err));
    }
}

function* getECheckInStatus(payload) {
    const start = new Date();

    try {
        yield put({ type: types.GET_ECHECKIN_STATUS_PENDING });
        const status = yield call(eCheckInStatus, payload.userName, payload.csnId, payload.token);
        const statusObj = { userName: payload.userName, csnId: payload.csnId, status: status };
        logAPI("MBHWeb.Saga.Epic.GetECheckInStatus", start, null);
        yield put({ type: types.GET_ECHECKIN_STATUS_SUCCESS, eCheckInStatus: status });
    }
    catch (err) {
        logAPI("MBHWeb.Saga.Epic.GetECheckInStatus.Failure", start, null, JSON.stringify(err));
        yield put({ type: types.GET_ECHECKIN_STATUS_FAILURE });
    }
}


function* handleEncryptCSN(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_EPIC_ENCRYPT_CSN_PENDING });
        if (domain.t && payload.csnId) {
            const response = yield call(encryptCSN, payload.csnId, domain.t);
            const statusObj = { payloadCsnId: payload.csnId, response };
            logAPI("MBHWeb.Saga.Epic.EncryptCSN", start, null, statusObj);
            yield put({ type: types.GET_EPIC_ENCRYPT_CSN_SUCCESS, encryptCSN: response });
        } else {
            logAPI("MBHWeb.Saga.Epic.EncryptCSN.Failure", start, null);
            yield put({ type: types.GET_EPIC_ENCRYPT_CSN_FAILURE });
        }
    }
    catch (err) {
        logAPI("MBHWeb.Saga.Epic.EncryptCSN.Failure", start, null, JSON.stringify(err));
        yield put({ type: types.GET_EPIC_ENCRYPT_CSN_FAILURE });
    }
}
